module.exports = __webpack_public_path__ + "Posters0012-21471b9673ad1a1be8a0bbe4dfca2c34.png";